import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetCiudadanosInfo } from '../../../shared/interfaces/database/pqrsd';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CiudadanosService {
  private readonly apiUrl = `${environment.apiUrl}/api/pqrsd/ciudadanos`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Obtiene la información detallada de un ciudadano asociado a una solicitud
   * @param solicitudId ID de la solicitud
   * @returns Observable con la información del ciudadano
   */
  getCiudadanosInfo(solicitudId: number): Observable<IGetCiudadanosInfo> {
    return this.http.get<IGetCiudadanosInfo>(`${this.apiUrl}/info/${solicitudId}`);
  }
}
